import Echo from "laravel-echo";
import Pusher from "pusher-js";

// Initialize Pusher (required by Laravel Echo, even for Reverb)
window.Pusher = Pusher;

// Read Reverb config from server-injected meta tags (runtime, not build-time)
function meta(name: string): string {
    return (
        document
            .querySelector(`meta[name="${name}"]`)
            ?.getAttribute("content") ?? ""
    );
}

const reverbKey = meta("reverb-key") || import.meta.env.VITE_REVERB_APP_KEY;
const reverbHost = meta("reverb-host") || import.meta.env.VITE_REVERB_HOST;
const reverbPort = meta("reverb-port") || import.meta.env.VITE_REVERB_PORT;
const reverbScheme =
    meta("reverb-scheme") || import.meta.env.VITE_REVERB_SCHEME || "https";

// Initialize Laravel Echo for real-time broadcasts
window.Echo = new Echo({
    broadcaster: "reverb",
    key: reverbKey,
    wsHost: reverbHost,
    wsPort: Number(reverbPort) || 80,
    wssPort: Number(reverbPort) || 443,
    forceTLS: reverbScheme === "https",
    enabledTransports: ["ws", "wss"],
});
